/**
 * Formats a number with 2 decimal places using German locale format.
 * Always uses German format (12.300,33) regardless of locale parameter.
 */
export function formatNumber(value: number): string {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * Formats an integer (no decimal places) using German locale format.
 * Always uses German format (12.300) regardless of locale parameter.
 */
export function formatInteger(value: number): string {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}
